<template>
  <div class="save-consent-root" :class="{ 'save-consent-root--block': block }">
    <p v-if="error" class="text-danger fw-bold mb-2">{{ error }}</p>

    <MDBBtn
      color="danger"
      class="save-consent-btn"
      :class="{ 'w-100': block }"
      :disabled="disabled || loading"
      @click="handleClick"
    >
      <span>{{ loading ? $t('consents.saving') : $t('consents.saveConsents') }}</span>
    </MDBBtn>

    <p v-if="disabled && hint" class="text-danger font-12 mt-2 mb-0 save-consent-hint">
      {{ hint }}
    </p>
    <p v-else-if="!disabled && !error" class="success-green font-12 mt-2 mb-0">
      {{ $t('consents.allRequiredAccepted') }}
    </p>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { MDBBtn } from "mdb-vue-ui-kit";

const props = defineProps({
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  error: { type: String, default: null },
  hint: { type: String, default: null },
  /** Full-width button (e.g. mobile modal footer). */
  block: { type: Boolean, default: false },
});

const emit = defineEmits(["save"]);

const handleClick = () => {
  if (!props.disabled && !props.loading) {
    emit("save");
  }
};
</script>

<style lang="scss" scoped>
.save-consent-root--block {
  text-align: left;
}

.save-consent-root--block .save-consent-hint {
  text-align: left;
}
</style>
